import singleSimDetailType from "./singleSimDetailType";

//product
export const successFetchedSingleSimDetail =(data)=>({
type: singleSimDetailType.SUCCESS_FETCHIED_SINGLE_SIM_DETAILS,
payload: data
 })
export const failureFetchedSingleSimDetail =(data)=>({
type: singleSimDetailType.FAILURE_FETCHED_SINGLE_SIM_DETAILS,
errorMessage: data
 })


//exercise
export const startFethingExercise = (id) => ({
  type: singleSimDetailType.START_FETCHING_EXERCISE_DETAILS,
  id,
});

 export const successFetchedExercise =(data)=>({
type: singleSimDetailType.SUCCESS_FETCHIED_EXERCISE_DETAILS,
payload: data
 })
export const failureFetchedExercise =(data)=>({
type: singleSimDetailType.FAILURE_FETCHED_EXERCISE_DETAILS,
errorMessage: data
 })


 //quiz
 export const startFetchingQuiz = (id) => ({
  type: singleSimDetailType.START_FETCHING_QUIZ_DETAILS,
  id,
});
export const successFetchedQuiz =(data)=>({
type: singleSimDetailType.SUCCESS_FETCHIED_QUIZ_DETAILS,
payload: data
 })
export const failureFetchedQuiz =(data)=>({
type: singleSimDetailType.FAILURE_FETCHED_QUIZ_DETAILS,
errorMessage: data
 })

